import clsx from 'clsx'
import {
  Card,
  Form,
  FormInstance,
  Input,
  RichTextEditor,
  Select,
} from 'components/common'
import { LedgerItemCategory } from 'lib/constants'
import { useState } from 'react'

export interface SelectAndDescriptionProps {
  title?
  description?: string
  loading?: boolean
  maxTitleLength?: number
  maxDescriptionLength?: number
  defaultValue?: string
  // form: FormInstance<SelectAndDescriptionFormValues>
}

export interface SelectAndDescriptionFormValues {
  title: string
  ledgerItemCategory: string
  description?: string
}

const classOptions = Object.entries(LedgerItemCategory).map(([key, value]) => (
  <Select.Option key={key} value={key}>
    {value}
  </Select.Option>
))

export const SelectAndDescription = ({
  title,
  description,
  maxTitleLength,
  maxDescriptionLength,
  loading = false,
}: SelectAndDescriptionProps): JSX.Element => {
  return (
    <>
      <Card shadow loading={loading}>
        <div className={clsx('mb-8')}>
          <Form.Item
            label="タイトル"
            labelCol={{ span: 24 }}
            name={'title'}
            initialValue={title}
            rules={[
              { required: true, message: 'タイトルは必須です。' },
              maxTitleLength > 0 && {
                max: maxTitleLength,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
        </div>
        <div className={clsx('mb-8')}>
          {/* 項目 */}
          <Form.Item
            name={'ledgerItemCategory'}
            label="項目"
            required
            rules={[{ required: true }]}
            style={{ width: '100%' }}
          >
            <Select
              placeholder="項目を選択してください"
              style={{ width: '100%' }}
            >
              {classOptions}
            </Select>
          </Form.Item>
        </div>

        <div>
          <Form.Item
            label="説明"
            name={'description'}
            initialValue={description}
            rules={[
              maxDescriptionLength > 0 && {
                max: maxDescriptionLength,
              },
            ]}
          >
            <RichTextEditor defaultValue={description} />
          </Form.Item>
        </div>
      </Card>
    </>
  )
}
